<template>
  <div class="card width-535">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content columns is-marginless is-multiline">
      <section class="has-text-centered column is-12">
            <span class="is-size-3 has-text-weight-bold">
              {{ $t('editionDemandeImpression.popUpDemandeImpresssion.title') }}
            </span>
      </section>
      <div class="column is-12 is-paddingless" v-if="errorsDemandeImpressionPopUp.length > 0">
        <error-msg-component :messages="errorsDemandeImpressionPopUp"
                             :error="errorsDemandeImpressionPopUp.length > 0"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errorsDemandeImpressionPopUp = []"/>
      </div>
      <div class="column is-12 is-paddingless mgt-20px">
        <b-field class="obligatoire"
                 :label="$t('editionDemandeImpression.popUpDemandeImpresssion.date')">
          <b-datepicker show-week-number
                        nearby-selectable-month-days
                        v-model="demandeImpression.date"
                        icon="calendar-today"
                        :editable="true">
          </b-datepicker>
        </b-field>
      </div>
      <div class="column is-12 is-paddingless mgt-20px">
        <selection-campagne
          :label="$t('editionDemandeImpression.popUpDemandeImpresssion.campagne')"
          :dcf="demandeImpression.campagnePourImpression"
          :avecLogo="true">
        </selection-campagne>
      </div>
      <main class="column is-12 is-paddingless mgt-20px">
        <div class="has-text-centered">
          <button class="button btn-modal-annuler is-cancel has-text-centered mg-button-modal"
                  @click="$emit('close')">
            {{ $t('general.button.cancel') }}
          </button>
          <button
            class="button is-warning has-text-centered mg-button-modal"
            @click="dataValidation()">
            {{ $t('general.button.apply') }}
          </button>
        </div>
      </main>
    </div>
  </div>
</template>

<script>

import selectionCampagne from '@/components/devisCommandes/selectionCampagne';
import errorMsgComponent from '@/components/general/errorMsgComponent';

export default {
  name: 'popUpImpression',
  data() {
    return {
      errorsDemandeImpressionPopUp: [],
      demandeImpression: {
        date: new Date(),
        campagnePourImpression: { campagneId: null },
      },
    };
  },
  components: {
    errorMsgComponent,
    selectionCampagne,
  },
  methods: {
    dataValidation() {
      if (this.demandeImpression.date == null) {
        this.errorsDemandeImpressionPopUp.push({ message: 'editionDemandeImpression.popUpDemandeImpresssion.errors.date' });
      } else {
        this.$emit('impression', this.demandeImpression);
      }
    },
  },
};
</script>
